import { Component, Input } from '@angular/core';
import { ElementTypeUniqueIdentifier, ViewState } from 'src/common';
import { ElementMode, ElementViewModel } from '../elements.model';

@Component({
	selector: 'element',
	templateUrl: './element.component.html'
})
export class ElementComponent {
	@Input() mode: ElementMode = ElementMode.Definition;
	@Input() state: ViewState;
	viewState = ViewState;
	elementTypeUniqueIdentifier = ElementTypeUniqueIdentifier;
	@Input() element: ElementViewModel;
}
